<div class="title">
  შეიყვანე საკონტაქტო ინფორმაცია
</div>
<form [formGroup]="form">
<div class="row">
  <div class="col-lg-6">
    <div class="form-group">
      <div class="d-flex">
        <label for="exampleInputEmail1">ელ.ფოსტა</label>
      </div>
      <div class="mb-l ta-l pos-r" *ngIf="form.get('email'); let email;">
      <input name="email" class="form-control" placeholder="namesurname@mail.com" formControlName="email" [ngClass]="{'has-error': !email.valid && submitted}"/>
    </div>

    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group mt-lg-0 mt-md-4 mobile-space">
      <div class="d-flex">
        <label for="exampleInputEmail1">მობილურის ნომერი</label>
      </div>
      <div class="mb-l ta-l pos-r" *ngIf="form.get('phone'); let phone;">
      <input name="phone" (keypress)="numberOnly($event)" maxlength="9" [ngClass]="{'has-error': !phone.valid && submitted}" class="form-control" placeholder="5XX XX XX XX" formControlName="phone"/>
    </div>

    </div>
  </div>
</div>
  <div class="sheet-buttons g g--spaceAround g--wrap g--nowrap@s g--alignEnd mt-5">
    <app-prev-btn></app-prev-btn>
    <app-next-btn (click)="onSubmit()"></app-next-btn>
  </div>
</form>
